import React, { useRef } from "react";
import { Link } from "react-router-dom";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import useRevealOnScroll from "../../general/components/common/useRevealOnScroll";
import serviciosFooterThemes from "../components/serviciosFooterThemes";
import wellnessImg from "../assets/home-wellness.jpg"
import homeTecnologicosImg from "../assets/home-tecnologicos.jpg";
import homePoliticasPublicasImg from "../assets/home-politicas-publicas.jpg";

const serviciosNavTheme = {
    primary: "#3f3f46",
    primaryDark: "#18181b",
    primaryLight: "#d4d4d8",
    pale: "#f4f4f5",
};

function SectorIcon({ type }) {
    const iconProps = {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.8,
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };

    const icons = {
        hospital: (
            <>
                <path d="M4.5 20.5h15" />
                <path d="M6.5 20.5v-13l5.5-3 5.5 3v13" />
                <path d="M9 10.5h6" />
                <path d="M12 7.5v6" />
                <path d="M9.5 20.5v-4h5v4" />
            </>
        ),
        pharma: (
            <>
                <path d="M8 15.5 15.5 8a3.2 3.2 0 0 1 4.5 4.5L12.5 20A3.2 3.2 0 0 1 8 15.5Z" />
                <path d="m12.2 11.3 4.5 4.5" />
                <path d="M5 6.5h5" />
                <path d="M7.5 4v5" />
            </>
        ),
        company: (
            <>
                <path d="M5.5 20.5v-14h8v14" />
                <path d="M13.5 10.5h5v10" />
                <path d="M8 9h2" />
                <path d="M8 12.5h2" />
                <path d="M8 16h2" />
                <path d="M16 14h.5" />
                <path d="M16 17h.5" />
            </>
        ),
        education: (
            <>
                <path d="M4 9.5 12 5l8 4.5-8 4.5-8-4.5Z" />
                <path d="M7 12v4c1.2 1.4 2.9 2.1 5 2.1s3.8-.7 5-2.1v-4" />
                <path d="M20 9.5v5" />
            </>
        ),
        public: (
            <>
                <path d="M4.5 20.5h15" />
                <path d="M5.5 8.5 12 4l6.5 4.5H5.5Z" />
                <path d="M7 10.5v7" />
                <path d="M12 10.5v7" />
                <path d="M17 10.5v7" />
            </>
        ),
        healthtech: (
            <>
                <path d="M12 4 19 8v8l-7 4-7-4V8l7-4Z" />
                <path d="M8 12h2.2l1.3-2.5 2.1 5 1.2-2.5H16" />
                <circle cx="12" cy="4" r="1" />
                <circle cx="19" cy="16" r="1" />
                <circle cx="5" cy="16" r="1" />
            </>
        ),
        professional: (
            <>
                <path d="M7 5v5a5 5 0 0 0 10 0V5" />
                <path d="M9 5H6" />
                <path d="M18 5h-3" />
                <path d="M12 15v1.5a3.5 3.5 0 0 0 7 0V15" />
                <circle cx="19" cy="13.5" r="1.5" />
            </>
        ),
        media: (
            <>
                <path d="M5 12a7 7 0 0 1 14 0" />
                <path d="M8 12a4 4 0 0 1 8 0" />
                <circle cx="12" cy="12" r="1.6" />
                <path d="M12 14v5" />
                <path d="M9 19h6" />
            </>
        ),
    };

    return (
        <span className={`sector-icon sector-icon-${type}`} aria-hidden="true">
            <svg {...iconProps}>{icons[type]}</svg>
        </span>
    );
}

export default function Servicios() {
    const pageRef = useRef(null);
    useRevealOnScroll(pageRef);

    return (
        <div className="servicios" ref={pageRef}>
            <SiteNavbar
                activeSection="servicios"
                ctaLabel="Solicitar consultoría"
                ctaHref="#contacto"
                navTheme={serviciosNavTheme}
            />

            <section className="hero">
                <div className="hero-inner">
                    <div className="hero-bread">
                        <Link to="/">FISP </Link> › Servicios Empresariales
                    </div>
                    <h1>
                        Servicios para el
                        <br />
                        sector salud.
                    </h1>
                    <p className="hero-sub">
                        Wellness corporativo. Consultoría digital. Marketing.
                        Producción de eventos. Servicios médicos.
                        Capacitación. Políticas públicas e inteligencia
                        institucional.
                    </p>
                    <div className="hero-links">
                        <a href="#contacto">
                            Solicitar consultoría
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </a>
                        <a href="#servicios">
                            Conocer los servicios
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </a>
                    </div>
                    <div className="hero-divider"></div>
                </div>
            </section>

            <div id="servicios">
                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid">
                            <div className="srv-text">
                                <div className="num">01</div>
                                <h2>Wellness Corporativo</h2>
                                <p>
                                    Programas de bienestar para empresas con
                                    charlas especializadas en salud mental,
                                    nutrición, manejo del estrés y hábitos
                                    saludables. Experiencias in-house y
                                    virtuales para equipos de trabajo.
                                </p>
                                <Link to="/servicios/wellness-corporativo" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src={wellnessImg}
                                    alt="Charla corporativa de wellness"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid flip">
                            <div className="srv-text">
                                <div className="num">02</div>
                                <h2>Proyectos Tecnológicos en Salud</h2>
                                <p>
                                    Historia clínica única, telemedicina de
                                    centros médicos y de emergencia, sistemas de
                                    agentes de IA médicos, desarrollo de
                                    plataformas y proyectos tecnológicos para
                                    instituciones médicas y gubernamentales.
                                </p>
                                <Link to="/servicios/proyectos-tecnologicos" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src={homeTecnologicosImg}
                                    alt="Profesionales médicos analizando datos en múltiples pantallas"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid">
                            <div className="srv-text">
                                <div className="num">03</div>
                                <h2>Marketing y Publicidad en Salud</h2>
                                <p>
                                    Estrategias de posicionamiento, campañas
                                    publicitarias, branding y marketing digital
                                    para empresas, productos farmacéuticos y
                                    profesionales. +350K seguidores de alcance
                                    en redes FISP.
                                </p>
                                <Link to="/servicios/marketing-publicidad" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80"
                                    alt="Equipo de marketing planificando estrategia de campaña"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid flip">
                            <div className="srv-text">
                                <div className="num">04</div>
                                <h2>Servicios Médicos</h2>
                                <p>
                                    Servicio de área cardioprotegida y
                                    colocación de DEA, capacitación en RCP
                                    virtual, entrenamiento de motos médicas y
                                    servicios digitales de nutrición
                                    empresarial.
                                </p>
                                <Link to="/servicios/servicios-medicos" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src="https://images.pexels.com/photos/11655091/pexels-photo-11655091.jpeg?auto=compress&cs=tinysrgb&w=800"
                                    alt="Persona enseñando RCP con DEA conectado al maniquí"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid">
                            <div className="srv-text">
                                <div className="num">05</div>
                                <h2>Producción de Contenido y Cobertura de Eventos</h2>
                                <p>
                                    Producción audiovisual profesional,
                                    cobertura integral de congresos, jornadas y
                                    eventos de salud con difusión en FISP TV,
                                    YouTube, Spotify y redes sociales.
                                </p>
                                <Link to="/servicios/produccion-eventos" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src="https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=800"
                                    alt="Back de estudio de TV filmando a una médica"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid flip">
                            <div className="srv-text">
                                <div className="num">06</div>
                                <h2>Capacitación Laboral para la Industria de la Salud</h2>
                                <p>
                                    Cursos in-company, talleres técnicos,
                                    programas de actualización profesional y
                                    certificación con respaldo FISP y Facultad
                                    de Medicina de la Universidad de Buenos
                                    Aires.
                                </p>
                                <Link to="/servicios/capacitacion-laboral" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&q=80"
                                    alt="Charla corporativa en empresa farmacéutica"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="srv-section reveal">
                    <div className="srv-inner">
                        <div className="srv-grid">
                            <div className="srv-text">
                                <div className="num">07</div>
                                <h2>Políticas Públicas e Inteligencia Institucional</h2>
                                <p>
                                    Monitoreo y análisis de impacto de políticas
                                    públicas en salud, entrenamiento en vocería
                                    institucional para organizaciones de salud y
                                    sectores regulados.
                                </p>
                                <Link to="/servicios/politicas-publicas-inteligencia-institucional" className="learn">
                                    <span>Más Información</span>
                                    <span className="learn-arrow" aria-hidden="true">-&gt;</span>
                                </Link>
                            </div>
                            <div className="srv-visual" style={{ padding: "0" }}>
                                <img
                                    src={homePoliticasPublicasImg}
                                    alt="Profesionales en una reunión de análisis institucional"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "20px",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <section className="sectors reveal">
                <div className="sec-inner">
                    <div className="sec-head">
                        <h2>Sectores que atendemos</h2>
                        <p>Trabajamos con toda la cadena de salud.</p>
                    </div>
                    <div className="sec-grid">
                        <div className="sec-pill">
                            <SectorIcon type="hospital" />
                            <h4>Hospitales y clínicas</h4>
                            <p>Público y privado</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="pharma" />
                            <h4>Laboratorios pharma</h4>
                            <p>Industria farmacéutica</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="company" />
                            <h4>Empresas</h4>
                            <p>Wellness y RRHH</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="education" />
                            <h4>Universidades</h4>
                            <p>Formación y eventos</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="public" />
                            <h4>Organismos públicos</h4>
                            <p>Gobierno y salud</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="healthtech" />
                            <h4>Healthtech</h4>
                            <p>Startups de salud</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="professional" />
                            <h4>Profesionales</h4>
                            <p>Marketing personal</p>
                        </div>
                        <div className="sec-pill">
                            <SectorIcon type="media" />
                            <h4>Medios y seguros</h4>
                            <p>Contenido y cobertura</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta" id="contacto">
                <div className="cta-inner">
                    <h2>Empecemos a trabajar.</h2>
                    <p className="cta-sub">
                        Completá el formulario y nuestro equipo se pone en
                        contacto en menos de 24 horas para armar una propuesta a
                        medida.
                    </p>
                    <div className="cta-form-wrap">
                        <div className="fg">
                            <label>Nombre y apellido</label>
                            <input type="text" placeholder="Ej: María González" />
                        </div>
                        <div className="fg">
                            <label>Empresa / Institución</label>
                            <input type="text" placeholder="Nombre de la empresa" />
                        </div>
                        <div className="fg">
                            <label>Email corporativo</label>
                            <input type="email" placeholder="nombre@empresa.com" />
                        </div>
                        <div className="fg">
                            <label>Servicio de interés</label>
                            <select>
                                <option value="">Seleccioná un servicio</option>
                                <option>Wellness Corporativo</option>
                                <option>Proyectos Tecnológicos en Salud</option>
                                <option>Marketing y Publicidad en Salud</option>
                                <option>Servicios Médicos</option>
                                <option>Producción y Cobertura de Eventos</option>
                                <option>Capacitación Laboral</option>
                                <option>Políticas Públicas e Inteligencia Institucional</option>
                                <option>Varios</option>
                            </select>
                        </div>
                        <div className="fg">
                            <label>Mensaje (opcional)</label>
                            <textarea
                                rows="3"
                                placeholder="Contanos brevemente sobre tu proyecto..."
                            ></textarea>
                        </div>
                        <button className="btn-submit">
                            Enviar consulta
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </section>

            <SiteFooter />
        </div>
    );
}
